import moment from 'moment-timezone';

import { ChartDateInterval } from '../../widget-chart/widget-chart.component';
import { Article } from './article';

const formatStringsByDateInterval: { [key in ChartDateInterval]: string } = {
  minute: 'DD MMM YYYY HH:mm',
  hour: 'DD MMM YYYY HH[h]',
  day: 'DD MMM YYYY',
  week: "DD MMM [']YY",
  month: "MMM [']YY",
  quarter: "[Q]Q [']YY",
  year: 'YYYY',
};

export interface Story {
  heading: string;
  contents: StoryContent[];
}

export interface StoryContent {
  subHeader: string;
  insight?: string;
}

export interface Journalist {
  widgetSettingsHash(): number;
  writeStory(article: Article, errorCallback?: (...args) => void): Story;
}

export function formatStoryDate(date, timezone, dateInterval) {
  if (date) {
    return moment.tz(date, timezone).format(formatStringsByDateInterval[dateInterval]);
  }
}
